<template>
  <div id="main" class="hander-car">
    <div class="store-content">
      <div class="cart-box">
        <div class="title">
          <h2>购物清单</h2>
        </div>
        <div class="cart-inner">
          <div class="empty-label hide">
            <h3>您的购物车中还没有商品</h3>
            <a class="link" href="javascript:;">现在选购</a>
          </div>
          <div>
            <div class="cart-table-title">
              <span class="name">商品信息</span>
              <span class="operation">操作</span>
              <span class="subtotal">小计</span>
              <span class="num">数量</span>
              <span class="price">单价</span>
            </div>
            <div class="cart-table">
              <div class="cart-group">
                <!--购物列表-->
                <div class="cart-top-items" v-for="item in carPanelData" :key="item.goods_id">
                  <div class="cart-items">
                    <div class="items-choose">
                      <span class="blue-checkbox-new" :class="{ 'checkbox-on': item.checked }"
                        @click="checkGoodsHandle(item.goods_id)"><a></a></span>
                    </div>
                    <div class="items-thumb">
                      <img :src="item.img" />
                      <a href="javascript:;" target="_blank"></a>
                    </div>
                    <div class="name hide-row">
                      <div class="name-table">
                        <a href="javascript:;" target="_blank">{{
                          item.title
                        }}</a>
                        <ul class="attribute">
                          <li style="
                              width: 300px;
                              overflow: hidden;
                              text-align: center;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            ">
                            {{ item.info }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="operation">
                      <a class="items-delete-btn" @click="delCarPanelHandler(item)"></a>
                    </div>
                    <div class="subtotal">¥{{ item.price * item.count }}</div>
                    <div class="item-cols-num">
                      <div class="select js-select-quantity">
                        <span class="down" :class="{ 'down-disabled': item.count <= 1 }"
                          @click="subCarPanelData(item.goods_id)">-</span>
                        <span class="num">
                          <input type="text" style="display: inline-block" v-model.lazy="item.count" />
                        </span>
                        <span class="up" :class="{
                          'up-disabled': item.count >= item.limit_num,
                        }" @click="pulsCarPanelData(item.goods_id)">+</span>
                      </div>
                    </div>
                    <div class="price">¥ {{ item.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-bottom-bg fix-bottom">
          <div class="cart-bar-operation">
            <div>
              <div class="choose-all js-choose-all">
                <span class="blue-checkbox-new" :class="{ 'checkbox-on': allChecked }"
                  @click="allCheckHandle(allChecked)"><a></a></span>
                全选
              </div>
              <div class="delete-choose-goods" @click="delCheckedGoodsHandler">
                删除选中的商品
              </div>
            </div>
          </div>
          <div class="shipping">
            <div class="shipping-box">
              <div class="shipping-total shipping-num">
                <h4 class="">
                  已选择 <i>{{ checkedCount }}</i> 件商品
                </h4>
                <h5>
                  共计 <i>{{ totalCount }}</i> 件商品
                </h5>
              </div>
              <div class="shipping-total shipping-price">
                <h4 class="">
                  应付总额：<span>￥</span><i>{{ checkedPrice }}</i>
                </h4>
                <h5 class="shipping-tips">应付总额不含运费</h5>
              </div>
            </div>
            <span class="jianguo-blue-main-btn big-main-btn js-checkout"
              :class="{ 'disabled-btn': !checkedCount > 0 }"><a @click="goRoute()">现在结算</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/cart.css";
export default {
  data() {
    return {
      carPanelData: [],
    };
  },
  mounted() {
    this.carPanelData = this.$store.state.carPanelData;
  },
  beforeUpdate() {
    this.carPanelData = this.$store.state.carPanelData;
  },
  computed: {
    //判断全选
    allChecked() {
      return this.$store.getters.allChecked;
    },
    //购物车总数
    totalCount() {
      return this.$store.getters.count;
    },
    //购物车选中数量
    checkedCount() {
      return this.$store.getters.checkedCount;
    },
    //购物车选中数量总结
    checkedPrice() {
      return this.$store.getters.checkedPrice;
    },
  },
  methods: {
    goRoute() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      if (userData == null) {
        return this.$message({
          message: '请先登录',
          type: 'error'
        });
      }
      this.$router.push('/checkout')
    },
    delCarPanelHandler(item) {
      this.$store.commit("deleteCar", item);
    },
    subCarPanelData(id) {
      this.$store.commit("subCarPanelData", id);
    },
    pulsCarPanelData(id) {
      this.$store.commit("pulsCarPanelData", id);
    },
    checkGoodsHandle(id) {
      this.$store.commit("checkGoodsHandle", id);
    },
    allCheckHandle(isAllChecked) {
      this.$store.commit("allCheckHandle", isAllChecked);
    },
    delCheckedGoodsHandler() {
      this.$store.commit("delCheckedGoodsHandler");
    },
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/cart.vue